export default __webpack_public_path__ + "static/media/goshen12.b6917705.jpg";